module.exports = __webpack_public_path__ + "img/karagandy5.d62ed605.jpg";